import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";
import {SetStateFn} from "@/utils/SetStateUtils";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import LoyaltyRewardHeadingActions from "@widgets/loyaltyRewards/editor/heading/LoyaltyRewardHeadingActions";

type Props = {
    route: Route,
    initialLoading: boolean,
    loyaltyReward: LoyaltyRewardDetails | null,
    setLoyaltyReward: SetStateFn<LoyaltyRewardDetails | null>,
    setShowDeleteModal: SetStateFn<boolean>,
};

const LoyaltyRewardHeading = ({
                                    route,
                                    initialLoading,
                                    loyaltyReward,
                                    setLoyaltyReward,
                                    setShowDeleteModal
                                }: Props) => {
    const intl = useIntl();

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={initialLoading ? intl.formatMessage(({id: "loyaltyReward"})) : route.name(intl)}
            actionRowHorizontal={false}
            actionRow={
                loyaltyReward === null
                    ? undefined
                    : <LoyaltyRewardHeadingActions
                        setShowDeleteModal={setShowDeleteModal}
                        setLoyaltyReward={setLoyaltyReward}
                    />
            }
            meta={<LocationPageMeta/>}
            breakpoints={{md: {actionRowHorizontal: true}}}
        />
    );
};

export default LoyaltyRewardHeading;